"use client"

import * as React from "react"
import { RefreshCw } from "lucide-react"

import { cn } from "../../lib/utils"

export interface IntroCardProps {
  className?: string
  title?: string
  introText: string
  onRefresh?: () => void
  isLoading?: boolean
}

function IntroCard({
  className,
  title = "Here's a quick intro we wrote for you:",
  introText,
  onRefresh,
  isLoading = false,
}: IntroCardProps) {
  return (
    <div
      className={cn(
        "bg-white border border-black rounded-lg p-4 shadow-[0px_4px_0px_0px_#000000]",
        className
      )}
    >
      {/* Header */}
      <div className="flex items-center justify-between mb-3">
        <span className="text-sm font-medium text-[#475467]">{title}</span>
        {onRefresh && (
          <button
            type="button"
            onClick={onRefresh}
            disabled={isLoading}
            className="p-1 hover:bg-gray-100 rounded-md transition-colors disabled:opacity-50"
            aria-label="Refresh intro"
          >
            <RefreshCw
              className={cn(
                "size-4 text-[#344054]",
                isLoading && "animate-spin"
              )}
            />
          </button>
        )}
      </div>

      {/* Intro Text */}
      <p className="text-sm text-[#ED5AA9] leading-relaxed">{introText}</p>
    </div>
  )
}

export { IntroCard }
